import React from 'react';
import { MessageSquare } from 'lucide-react';
import type { Theme } from '../types';
import { resolveThemeToken, isColorToken } from '../utils/theme';

interface MinimizedButtonProps {
  unreadCount: number;
  theme: Theme;
  onClick: () => void;
  controlsId?: string;
}

const MinimizedButton = React.memo(function MinimizedButton({
  unreadCount,
  theme,
  onClick,
  controlsId,
}: MinimizedButtonProps) {
  const background = resolveThemeToken(theme.secondary, 'backgroundColor');
  const text = resolveThemeToken(theme.text, 'color');
  const hoverClass = isColorToken(theme.hover) ? '' : theme.hover;
  const label =
    unreadCount > 0
      ? `Open chat (${unreadCount} unread message${unreadCount === 1 ? '' : 's'})`
      : 'Open chat';
  return (
    <button
      onClick={onClick}
      type="button"
      aria-label={label}
      aria-controls={controlsId}
      aria-haspopup="dialog"
      className={`relative rounded-full p-4 shadow-lg ${background.className} ${text.className} ${hoverClass} focus:outline-2 focus:outline-blue-500`}
      style={{ ...background.style, ...text.style }}
    >
      <MessageSquare className="w-6 h-6" aria-hidden="true" />
      {unreadCount > 0 && (
        <span
          className="absolute -top-1 -right-1 bg-red-600 text-gray-900 text-xs rounded-full px-1"
          aria-hidden="true"
        >
          {unreadCount}
        </span>
      )}
    </button>
  );
});

export default MinimizedButton;
